import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
@Component({
  selector: 'app-shopfloor-overview',
  templateUrl: './shopfloor-overview.component.html',
  styleUrls: ['./shopfloor-overview.component.scss'],
})
export class ShopfloorOverviewComponent implements OnInit {
  constructor(
    private datePipe: DatePipe,
    private generalService: GeneralService,
    private http: HttpClient
  ) {
    datePipe = new DatePipe('en-US');
  }

  apiUrl = 'https://srv-msgi.pmc.tn/api/';
  dateAujourdhui;
  debutPoste;
  finPoste;
  LignesFabricationsIds;

  chargement_mensuel;
  objectif_atelier;
  nbPoteaux;

  poidsParLigne: any[];

  data;

  async ngOnInit() {
    //await this.calculheuresPoste();

    this.fetchIndicateursProd();

    setInterval(() => {
      this.dateAujourdhui = this.getFormatedDate(new Date());
      this.fetchIndicateursProd();
    }, 60 * 1000);
  }

  getItemsByLigneFab(ligneId, column) {
    var a = this.data.filter(
      (item) => item.xLigneNum == ligneId && item.xLigneOrdre == column
    );
    return a;
  }

  getColumnsByLigneFab(ligneId) {
    var a = Array.from(
      new Set(
        this.data
          .filter((item) => item.xLigneNum == ligneId)
          .map((x) => x.xLigneOrdre)
      )
    );
    return a;
  }

  async fetchIndicateursProd() {
    var deb, fin: Date;
    deb = new Date();
    fin = new Date();

    deb.setHours(8);
    deb.setMinutes(0);

    var now: Date = new Date();

    var hfin;
    var mfin;

    if (now.getDay() == 5) {
      hfin = 13;
      mfin = 0;
    }
    if (now.getDay() == 6) {
      hfin = 14;
      mfin = 0;
    } else {
      hfin = 15;
      mfin = 0;
    }

    if (
      now.getHours() < hfin ||
      (now.getHours() == hfin && now.getMinutes() < mfin)
    ) {
      fin = now;
    } else {
      fin.setHours(hfin);
      fin.setMinutes(mfin);
    }

    this.data = await this.http
      .get(
        'http://srv-msgi.pmc.tn/api/msgi/IndicateursProd?dateDebut=' +
          this.getFormatedDate(deb) +
          '&dateFin=' +
          this.getFormatedDate(fin)
      )
      .toPromise();

    this.LignesFabricationsIds = this.data
      .filter(
        (thing, i, arr) =>
          this.data.findIndex((t) => t.xLigneNum === thing.xLigneNum) === i
      )
      .map((x) => x.xLigneNum)
      .sort((a, b) => a.localeCompare(b));

    var s = await this.generalService
      .customRequest(
        this.apiUrl + 'recherche/tbdata?tablere=API_ObjectifAtelier'
      )
      .toPromise();
    var r = await this.generalService
      .customRequest(
        this.apiUrl + 'recherche/tbdata?tablere=API_TableChargement'
      )
      .toPromise();

    this.chargement_mensuel = Math.floor(r[0]['Tonnage'] / 1000.0);
    this.objectif_atelier = s[0]['objectif_atelier'];
    this.nbPoteaux = r[0]['NbPoteaux'];

    this.poidsParLigne = await this.generalService
      .customRequest(
        this.apiUrl + 'recherche/tbdata?tablere=API_TotalPoidsParMachine'
      )
      .toPromise();

    //res.array.forEach(el => { this.poidsParLigne[el.ligne] = el.PoidsLigne });
  }

  getPoidsParLigne(ligne) {
    return this.poidsParLigne.find((x) => x.ligne == ligne).PoidsLigne;
  }

  getMinutes(d: Date) {
    return d.getHours() * 60 + d.getMinutes();
  }

  /*async calculheuresPoste() {

    let dataHorairesPostes: any[] = await this.generalService.rechercheTable('API_Horaire_Poste').toPromise();

    let now = this.getMinutes(new Date());


    let debutPoste2 = new Date();
    let finPoste2 = new Date();


    debutPoste2.setSeconds(0);
    finPoste2.setSeconds(0);

    dataHorairesPostes.forEach(poste => {
      let ddeb: Date = new Date("1/1/2000 " + poste.xHoraire_HeureDebut);
      let dfin: Date = new Date("1/1/2000 " + poste.xHoraire_HeureFin);

      let mdeb = this.getMinutes(ddeb);
      let mfin = this.getMinutes(dfin);


      if (now >= mdeb && now <= mfin) {
        debutPoste2.setHours(ddeb.getHours());
        debutPoste2.setMinutes(ddeb.getMinutes());

        finPoste2.setHours(dfin.getHours());
        finPoste2.setMinutes(dfin.getMinutes());
      }
      if (mdeb >= mfin && now <= mfin) {
        debutPoste2.setHours(ddeb.getHours());
        debutPoste2.setMinutes(ddeb.getMinutes());
        debutPoste2.setDate(debutPoste2.getDate() - 1);


        finPoste2.setHours(dfin.getHours());
        finPoste2.setMinutes(dfin.getMinutes());
      }

    })


    this.debutPoste = this.getFormatedDate(debutPoste2);
    this.finPoste = this.getFormatedDate(finPoste2);

  }*/

  getFormatedDate(d: Date) {
    return this.datePipe.transform(d.toISOString(), 'yyyyMMdd HH:mm');
  }
}
